export interface IMedia {
    media_id: number,
    name: string,
    leftName: string,
    rightName: string,
    url: string,
    fullname: string,
    download: number,
    reviews: number,
    fullImage: string,
    fullFirstFrame: string,
    fullSlideImage: string,
    city: ICity[],
    genre: IGenre[],
    status: boolean,
    date: string,
    director: IPerson[],
    actor: IPerson[],
    artist?: IPerson,
    filename: string,
    info: string,
    time: string,
    isFavorited: boolean,
    qualityName: string,
    translateName: string,
    videofile: string,
    seasonAndSeria?: string,
    year: number,
    age: number,
    imdb: number,
    critics: number,
    parent?: IMedia,
    seria?: string,
    isNew: boolean,
    fullpath: string,
    serialReviews?: number,
    resized?: string
};

export interface ICity {
    city_id: number,
    name: string
}
export interface ITag {
    tag_id: number,
    name: string
}

export interface IGenre {
    genre_id: number,
    name: string
}
export interface ICategory {
    category_id: number,
    parent_id: number,
    parent: ICategory,
    name: string
}

export interface IUser {
    username: string,
    id: number,
    email: string,
    fullpath: string,
    user_profile: IProfile
}

export interface IProfile {
    first: string,
    last: string,
    gender: number
}

export interface IBanner {
    banner_id: number,
    is_inner: number,
    path: string,
    fullPath: string,
    link: string,
    second: number
}

export interface IComment {
    user_id: number,
    user: IUser,
    content: string,
    status: number,
    id: number,
    likes: number,
    date: string
}

export interface IPerson {
    person_id: number,
    first: string,
    last: string,
    full: string,
    fullpath: string,
}

export interface IPagination {
    pageParam: string,
    totalCount: number,
    pageCount: number
}

export interface IVideoclubStat {
    genre: IGenre,
    count: number,
    fullpath: string
}

export interface ISeason {
    name: string,
    season: string,
    media_id: number
}

export enum EFilter {
    POPULAR = "popular",
    NEWEST = "newest"
}

export enum EPeriod {
    DAY = "DAY",
    WEEK = "WEEK",
    MONTH = "MONTH"
}

export enum EVideoclub {
    FILMS = "film",
    SERIALS = "serial",
    TRAILERS = "trailer"
}

export enum ELanguage {
    UZBEK = 1,
    RUSSIAN = 2,
    OTHER = 3
}